<template>
    <section class="section campaign-details">
        <div v-if="campaign">
            <campaign-image  :campaign="campaign" />
            <campaign-header :campaign="campaign" />
            <proposal v-if="campaign.is_active" :campaign="campaign" />
            <div v-else>
                We are no longer accepting new proposals for this campaign.
            </div>
        </div>
        <div class="box" v-else>
            Whoops! We could not find anything here. Please check
            back or contact support <span v-if="$root.account.support_email">
                at <a :href="`mailto:${$root.account.support_email}`">{{ $root.account.support_email }}</a>
            </span>.
        </div>
    </section>
</template>
<script>
    import CampaignImage from './CampaignImage.vue';
    import CampaignHeader from './CampaignHeader.vue';
    import Proposal from "./proposal/Proposal.vue";
    export default {

        /**
         * The component name
         *
         * @type {string}
         */
        name: 'Campaign',

        /**
         * The child components
         *
         * @type {object}
         */
        components: {
            Proposal,
            CampaignImage,
            CampaignHeader,
        },

        /**
         * The computed properties
         *
         * @type {object}
         */
        computed: {

            /**
             * The campaign id
             *
             * @returns {string}
             */
            campaign_id() {
                return this.$route.params.campaign_id;
            },

            /**
             * The current campaign
             *
             * @returns {object}
             */
            campaign() {
                return this.$root.getCampaign(this.campaign_id);
            },

            /**
             * The current campaign proposals
             *
             * @returns {array}
             */
            proposals() {
                return this.$root.campaignProposals(this.campaign_id);
            },

            /**
             * Whether or not the user needs to provide their payment info
             *
             * @returns {boolean}
             */
            needs_paypal() {
                return this.campaign.makes_payments;
            },
        },

        /**
         * The component methods
         *
         * @type {object}
         */
        methods: {

            /**
             * Whether the campaign has the compensation method
             *
             * @param {string} method
             * @returns {boolean}
             */
            hasCompensation(method) {
                return this.campaign.compensation.indexOf(method) >= 0;
            },

            moveToTasks() {
                this.$nextTick(() => {
                    this.$root.moveTo(document.getElementById('campaign-tasks'))
                });
            }
        }
    }
</script>

